(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
/* ===== RNF: Menu Drawer Bottom Sheet PRO v3 (close like Dawn + tap outside + pull-down close) ===== */
(function(){
  if (window.__rnfSheetDrawerInitV3) return;
  window.__rnfSheetDrawerInitV3 = true;

  const CLOSE_THRESHOLD = 90; // px

  function getDetails(){
    return document.querySelector('details.menu-drawer-container');
  }

  function getParts(details){
    if(!details) return {};
    const drawer = details.querySelector('.menu-drawer');
    const inner  = drawer ? drawer.querySelector('.menu-drawer__inner-container') : null;
    const scroller =
      (drawer && drawer.querySelector('.menu-drawer__navigation-container')) ||
      (drawer && drawer.querySelector('.menu-drawer__menu')) ||
      inner || drawer;
    const overlay = details.querySelector('.menu-drawer__overlay');
    const summary = details.querySelector('summary');
    return { drawer, inner, scroller, overlay, summary };
  }

  // Cierre "como Dawn" (igual que la X): toggle del summary
  function closeLikeDawn(details){
    const { summary } = getParts(details);
    if (summary) summary.click();
    else details.removeAttribute('open');
  }

  function ensureDragZone(inner){
    if(!inner) return null;
    let dz = inner.querySelector('.rnf-drag-zone');
    if(!dz){
      dz = document.createElement('div');
      dz.className = 'rnf-drag-zone';
      inner.prepend(dz);
    }
    return dz;
  }

  function readBaseOverlay(){
    const v = getComputedStyle(document.documentElement).getPropertyValue('--rnf-overlay').trim();
    const n = parseFloat(v);
    return Number.isNaN(n) ? 0.55 : n;
  }

  function init(){
    const details = getDetails();
    if(!details) return;

    const { drawer, inner, scroller, overlay } = getParts(details);
    if(!drawer) return;

    // drag zone arriba
    const dz = ensureDragZone(inner);

    /* ---------- 1) Cerrar tocando fuera ---------- */
    // Overlay click (lo más fiable)
    if (overlay && !overlay.__rnfOutsideBoundV3){
      overlay.__rnfOutsideBoundV3 = true;
      overlay.addEventListener('click', (e) => {
        if (!details.hasAttribute('open') && !details.open) return;
        e.preventDefault();
        e.stopPropagation();
        closeLikeDawn(details);
      }, { passive: false });
    }

    // Fallback: click fuera del drawer (captura)
    if (!document.__rnfDocOutsideBoundV3){
      document.__rnfDocOutsideBoundV3 = true;
      document.addEventListener('pointerdown', (e) => {
        const d = getDetails();
        if(!d || !(d.open || d.hasAttribute('open'))) return;

        const { drawer: dr } = getParts(d);
        if(!dr) return;

        if (!dr.contains(e.target)) {
          e.preventDefault();
          closeLikeDawn(d);
        }
      }, { capture: true, passive: false });
    }

    /* ---------- 2) Cerrar arrastrando hacia abajo (pull-down) ---------- */
    let startY = 0;
    let dragging = false;

    function getY(ev){
      return (ev.touches && ev.touches[0]) ? ev.touches[0].clientY : ev.clientY;
    }

    function canStartPull(){
      // Solo si está abierto y el scroll está arriba
      if (!(details.open || details.hasAttribute('open'))) return false;
      const el = scroller || inner || drawer;
      if (!el) return true;
      // Si es scrollable y NO está arriba, no iniciamos cierre
      return (el.scrollTop || 0) <= 0;
    }

    function onDown(e){
      if (!canStartPull()) return;
      dragging = true;
      startY = getY(e);

      drawer.style.setProperty('transition', 'none', 'important');
      if (overlay) overlay.style.setProperty('transition', 'none', 'important');

      if (e.cancelable) e.preventDefault();

      window.addEventListener('touchmove', onMove, { passive: false });
      window.addEventListener('mousemove', onMove, { passive: false });
      window.addEventListener('touchend', onUp, { passive: false });
      window.addEventListener('mouseup', onUp, { passive: false });
    }

    function onMove(e){
      if (!dragging) return;

      const y = getY(e);
      const delta = Math.max(0, y - startY);

      // sigue el dedo (gana a tu CSS !important)
      drawer.style.setProperty('transform', `translate3d(0, ${delta}px, 0)`, 'important');

      if (overlay){
        const base = readBaseOverlay();
        const t = Math.min(1, delta / CLOSE_THRESHOLD);
        overlay.style.setProperty('opacity', String(base * (1 - t)), 'important');
      }

      if (e.cancelable) e.preventDefault();
    }

    function onUp(e){
      if (!dragging) return;
      dragging = false;

      const y = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientY : (e.clientY || startY);
      const delta = Math.max(0, y - startY);

      // reset inline (deja a CSS controlar)
      drawer.style.removeProperty('transition');
      drawer.style.removeProperty('transform');
      if (overlay){
        overlay.style.removeProperty('transition');
        overlay.style.removeProperty('opacity');
      }

      if (delta > CLOSE_THRESHOLD) closeLikeDawn(details);

      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('mouseup', onUp);

      if (e && e.cancelable) e.preventDefault();
    }

// Bind al drawer, pero SOLO iniciamos drag si el gesto empieza en la zona superior (70px)
// o directamente sobre la drag-zone. Así no bloquea el contenido.
if (drawer && !drawer.__rnfPullBoundV3){
  drawer.__rnfPullBoundV3 = true;

  const TOP_ZONE = 70; // igual que tu altura del drag-zone

  function isInteractive(target){
    return !!(target && target.closest('a, button, summary, input, select, textarea, [role="button"]'));
  }

  function canStartFromHere(e){
    if (!(details.open || details.hasAttribute('open'))) return false;

    // Si has tocado algo interactivo del contenido, NO iniciar drag (deja clicks)
    if (isInteractive(e.target)) return false;

    // Si existe la drag-zone y estás dentro de ella, OK
    if (dz && dz.contains(e.target)) return true;

    // Si no, calcula si el toque está en los primeros TOP_ZONE px del drawer
    const y = getY(e);
    const rect = drawer.getBoundingClientRect();
    return (y - rect.top) <= TOP_ZONE;
  }

  function onDownGuard(e){
    // solo deja empezar si estás arriba
    if (!canStartFromHere(e)) return;

    // y además: solo si el scroll está arriba (tu lógica actual)
    if (!canStartPull()) return;

    onDown(e);
  }

  // Usa pointer + touch (sin mousedown para evitar dobles en móviles)
  drawer.addEventListener('pointerdown', onDownGuard, { passive: false });
  drawer.addEventListener('touchstart', onDownGuard, { passive: false });
}



    /* ---------- 3) ESC ---------- */
    if (!document.__rnfEscDrawerV3){
      document.__rnfEscDrawerV3 = true;
      document.addEventListener('keydown', (ev) => {
        const d = getDetails();
        if (ev.key === 'Escape' && d && (d.open || d.hasAttribute('open'))) closeLikeDawn(d);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();



/* ===== RNF: Desktop dim overlay V3 (detecta open por details + aria-expanded + submenu visible) ===== */
(function(){
  if (window.__rnfHeaderDimV3) return;
  window.__rnfHeaderDimV3 = true;

  const MQ = window.matchMedia('(min-width: 990px)');

  function ensureOverlay(){
    let el = document.getElementById('rnf-header-dim-overlay');
    if (!el) {
      el = document.createElement('div');
      el.id = 'rnf-header-dim-overlay';
      document.body.appendChild(el);
    }
    return el;
  }

  function getHeaderRoot(){
    return document.querySelector('.section-header');
  }

  function getOpenDetails(root){
    if (!root) return [];
    return Array.from(root.querySelectorAll('details[open]'))
      .filter(d => !d.classList.contains('menu-drawer-container'));
  }

  function hasExpandedToggle(root){
    if (!root) return false;
    return !!root.querySelector('[aria-expanded="true"]');
  }

  function hasVisibleSubmenu(root){
    if (!root) return false;

    // Dawn usa distintos wrappers según dropdown/mega/language/country
    const candidates = root.querySelectorAll(
      '.header__submenu, .mega-menu__content, .disclosure__list-wrapper, .menu-drawer__submenu'
    );

    for (const el of candidates) {
      const rect = el.getBoundingClientRect();
      // “visible real” (no solo en DOM)
      if (rect.width > 5 && rect.height > 5) return true;
    }
    return false;
  }

  function isOpen(){
    const root = getHeaderRoot();
    if (!root) return false;

    // 1) details[open]
    if (getOpenDetails(root).length) return true;

    // 2) toggles aria-expanded
    if (hasExpandedToggle(root)) return true;

    // 3) submenús visibles por tamaño
    if (hasVisibleSubmenu(root)) return true;

    return false;
  }

  function refresh(){
    if (!MQ.matches) {
      document.body.classList.remove('rnf-header-dim-on');
      return;
    }
    document.body.classList.toggle('rnf-header-dim-on', isOpen());
  }

  function closeAll(){
    const root = getHeaderRoot();
    if (!root) return;

    // Cierra details
    getOpenDetails(root).forEach(d => { d.open = false; });

    // Cierra toggles aria-expanded="true" (click para que Dawn haga su cierre correcto)
    root.querySelectorAll('[aria-expanded="true"]').forEach(btn => {
      try { btn.click(); } catch(e){}
    });

    refresh();
  }

  function bind(){
    const overlay = ensureOverlay();
    const root = getHeaderRoot();
    if (!root) return;

    // Click overlay => cerrar
    overlay.addEventListener('click', (e) => {
      if (!document.body.classList.contains('rnf-header-dim-on')) return;
      e.preventDefault();
      closeAll();
    });

    // ESC => cerrar
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('rnf-header-dim-on')) {
        closeAll();
      }
    });

    // Observa cambios en open + aria-expanded + class + style + DOM
    const mo = new MutationObserver(() => refresh());
    mo.observe(root, {
      subtree: true,
      attributes: true,
      childList: true,
      attributeFilter: ['open', 'aria-expanded', 'class', 'style']
    });

    MQ.addEventListener?.('change', refresh);

    // Fallback extra por si hay animaciones que “abren” tras un tick
    root.addEventListener('pointerdown', () => setTimeout(refresh, 0), true);
    root.addEventListener('click', () => setTimeout(refresh, 0), true);

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();


/* ===== RNF: detecta apertura del Search modal y baja SOLO el icono del menú ===== */
(function(){
  if (window.__rnfSearchOpenClass) return;
  window.__rnfSearchOpenClass = true;

  function bindOne(details){
    if (!details || details.__rnfBoundSearchToggle) return;
    details.__rnfBoundSearchToggle = true;

    const refresh = () => {
      document.body.classList.toggle('rnf-search-open', !!details.open);
    };

    details.addEventListener('toggle', refresh);
    refresh();
  }

  function init(){
    // Dawn: <details-modal> contiene un <details> interno
    document.querySelectorAll('details-modal details').forEach(bindOne);

    // fallback por si cambia el DOM
    const mo = new MutationObserver(() => {
      document.querySelectorAll('details-modal details').forEach(bindOne);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



  } catch(e) { console.error(e); }
})();
})();
